import { z } from 'zod';

export const HealthResponse = z
  .object({
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    db: z.enum(['ok', 'down']),
    time: z.string(),
  })
  .meta({
    id: 'Health',
    example: { status: 'ok', version: 'dev', db: 'ok', time: '2026-10-06T17:30:00.000Z' },
  });
export type HealthResponse = z.infer<typeof HealthResponse>;
